import Parametro from "./Parametro";
import { BaseModel } from "../../BaseModel";

export default class ContaParametro implements BaseModel {
    id: number;
    codigo: string;
    parametro: Parametro;
    valorTexto: string;
    valorInteiro: number | null;
    valorNumerico: number | null;
    valorHorario: number | null;
    valorBooleano: boolean | null;

    constructor(
        id: number = 0,
        codigo: string = "",
        parametro: Parametro = new Parametro(),
        valorTexto: string = "",
        valorInteiro: number = 0,
        valorNumerico: number = 0,
        valorHorario: number = 0,
        valorBooleano: boolean = false
    ) {
        this.id = id;
        this.codigo = codigo;
        this.parametro = parametro;
        this.valorTexto = valorTexto;
        this.valorInteiro = valorInteiro;
        this.valorNumerico = valorNumerico;
        this.valorHorario = valorHorario;
        this.valorBooleano = valorBooleano;
    }
}